/**
 * Numbers coming out of text inputs and stored config.
 *
 * The trap these exist for: `Number(null)` is 0, `Number("")` is 0, and both
 * are finite. A helper that only asks `Number.isFinite` therefore turns "no
 * value" into a hard zero - which is how a blank row count became 0 and then
 * failed its own validation, and how an unset ground clearance became 0 m
 * instead of the 0.5 m the engine falls back to, laying the rows on the ground
 * and taking their shadows with them. Absence is not zero.
 */

/** A finite number, or null for anything that is not one - blanks included. */
export function toFiniteNumber(value) {
  if (value == null) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  // Booleans and arrays coerce to numbers too, and never mean one here.
  if (typeof value === "boolean" || Array.isArray(value)) return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

/** The same value as a controlled input's string, blank for "no value". */
export function toFieldValue(value) {
  const num = toFiniteNumber(value);
  return num == null ? "" : String(num);
}
